import {
  Callout,
  CommandBarButton,
  DirectionalHint,
  Stack,
} from '@fluentui/react';
import React from 'react';
import { DetailsCallout } from './DetailsCallout';
import { useStyles } from './index.styles';
import { LookupSupplierSearch_lookupSupplierSearch_nodes } from 'common/graphql/__generated__/LookupSupplierSearch';

export interface SupplierLookUpCalloutProps {
  data: LookupSupplierSearch_lookupSupplierSearch_nodes[];
  onDismiss?: () => void;
  targetID: string;
  onSelect: (value: LookupSupplierSearch_lookupSupplierSearch_nodes) => void;
  lookUpCalloutWidth?: number;
  onAddNewSupplier?: () => void;
  isAddNewAvailable: boolean;
}

export const SupplierLookUpCallout: React.FC<SupplierLookUpCalloutProps> = ({
  onDismiss,
  data,
  targetID,
  onSelect,
  lookUpCalloutWidth,
  onAddNewSupplier,
  isAddNewAvailable,
}) => {
  const styles = useStyles();
  if (!data?.length) return null;

  return (
    <Callout
      onDismiss={onDismiss}
      gapSpace={10}
      isBeakVisible={false}
      className={styles.callout}
      directionalHint={DirectionalHint.bottomLeftEdge}
      target={targetID}
      style={{ width: lookUpCalloutWidth }}
    >
      <Stack className={styles.searchAreaContainer}>
        {isAddNewAvailable && (
          <CommandBarButton
            styles={{ root: { height: 50 } }}
            iconProps={{ iconName: 'add' }}
            text="Add new supplier"
            onClick={onAddNewSupplier}
          />
        )}
        <Stack>
          {data?.map((item, index) => {
            const detailsTargetId = `details${item.id
              ?.replace(/-+/g, '')
              .trim()}`;
            return (
              <DetailsCallout
                onSelect={onSelect}
                onDismiss={onDismiss}
                data={item}
                key={index.toString()}
                detailsTargetId={detailsTargetId}
              />
            );
          })}
        </Stack>
      </Stack>
    </Callout>
  );
};
